class CatalogSearch {
    search;
    searchForm;
    searchInput;
    searchResult;
    searchResultList;
    resultRowTemplate;
    notFoundTemplate;
    searchOverlay;
    #searchTimer;
    #previousSearchQuery;

    constructor(el) {
        this.search = el;
        this.searchForm = this.search.querySelector('form');
        this.searchResult = this.search.querySelector('.search__dropdown');
        this.searchResultList = this.searchResult.querySelector('ul');
        this.searchInput = this.search.querySelector('.search__input');
        this.resultRowTemplate = this.search.querySelector('template.resultRowTemplate');
        this.notFoundTemplate = this.search.querySelector('template.notFoundTemplate');
        this.searchOverlay = document.querySelector('.search__overlay');

        this.#bindEvents();
        this.#hideResult();
    }

    #bindEvents() {
        this.searchInput.addEventListener("input", (event) => {
            clearTimeout(this.#searchTimer);
            this.#searchTimer = setTimeout(() => {
                this.#search(event.target.value);
            }, 500);
        });

        const OnEscapePressed = (event) => event.key === 'Escape' && this.#EscapePressed();
        document.addEventListener('keydown', OnEscapePressed);

        this.searchForm.addEventListener("submit", (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.#search(this.searchInput.value);
        });

        this.searchOverlay.addEventListener("mouseup", () => this.#hideResult());
    }

    #showResult() {
        this.searchResult.classList.remove('d-none');
        this.searchOverlay.classList.add('_visible');
        this.search.classList.add('opened');
        document.documentElement.classList.add('_lock-scroll');
    }

    #hideResult() {
        this.searchResult.classList.add('d-none');
        this.searchOverlay.classList.remove('_visible');
        this.search.classList.remove('opened');
        clearTimeout(this.#searchTimer);
        document.documentElement.classList.remove('_lock-scroll');
    }

    #search(query) {
        if (!query) {
            this.#hideResult();
            return;
        }

        if (this.#previousSearchQuery === query) {
            this.#showResult();
            return;
        }

        let options = {
            method: 'GET',
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        };

        fetch('/catalogue/search?' + new URLSearchParams({query: query}), options)
            .then(response => response.json())
            .then(data => this.#applyResults(data));

        this.#previousSearchQuery = query;
    }

    #applyResults(results) {
        this.searchResultList.replaceChildren();
        results.forEach((element) => {
            let row = this.resultRowTemplate.content.cloneNode(true);
            row.querySelector('.dropdown-search__link').href = element.url;
            row.querySelector('.dropdown-search__name').textContent = element.title;
            row.querySelector('.dropdown-search__label').textContent = element.subTitle;
            this.searchResultList.appendChild(row);
        });

        if (results.length === 0) {
            let notFound = this.notFoundTemplate.content.cloneNode(true);
            this.searchResultList.appendChild(notFound);
        }

        this.#showResult();
    }

    #EscapePressed() {
        this.#hideResult();
    }
}